import { render } from "./CreateMatch.vue?vue&type=template&id=0232cd22&scoped=true"
import script from "./CreateMatch.vue?vue&type=script&lang=js"
export * from "./CreateMatch.vue?vue&type=script&lang=js"

import "./CreateMatch.vue?vue&type=style&index=0&id=0232cd22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0232cd22"]])

export default __exports__